import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_MOMENTUM_BAR = defineFcm('petition_page_momentum_bar')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				momentumBar: {
					type: 'object',
					shape: {
						enabled: { type: 'boolean' },
						experimentName: { type: 'string' },
					},
				},
				submodules: {
					type: 'record',
					keys: ['endorsements', 'commentsSummary', 'mediaMentions', 'sharesCount'] as const,
					optionalValues: true,
					shape: {
						type: 'object',
						optional: true,
						shape: {
							enabled: { type: 'boolean' },
							experimentName: { type: 'string' },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		momentumBar: {
			enabled: false,
			experimentName: '',
		},
		submodules: {
			endorsements: { enabled: false, experimentName: '' },
			commentsSummary: { enabled: false, experimentName: '' },
			mediaMentions: { enabled: false, experimentName: '' },
			sharesCount: { enabled: false, experimentName: '' },
		},
	})
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition details',
		description: 'FC to control the momentum bar on the petition page',
		import: false,
		template: {
			momentumBar: {
				enabled: false,
				experimentName: '',
			},
			submodules: {
				endorsements: {
					enabled: false,
					experimentName: '',
				},
				commentsSummary: {
					enabled: false,
					experimentName: '',
				},
				mediaMentions: {
					enabled: false,
					experimentName: '',
				},
				sharesCount: {
					enabled: false,
					experimentName: '',
				},
			},
		},
	});
